// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_sidebar__bs-lW {
  display: flex;
  flex: 1 1;
  height: 100%;
  min-width: 15%;
  max-width: 15%;
  position: sticky;
  overflow: hidden;
  margin-top: 25px;
  flex-direction: column;
  gap: 2rem;

}

.sidebar_sidebarWrapper__3cXMU {
  color: var(--hsrcDarkBlue);
  font-size: 16px;
}

.sidebar_sidebarMenu__0ckut {

  padding: 2rem;
}

.sidebar_sidebarTitle__lJclU {
  font-size: 13px;
  color: rgb(187, 186, 186);
}

.sidebar_sidebarSubListItem__ZkUS9 {
  padding-left: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 25px;
}

.sidebar_sidebarSubListItem__ZkUS9.sidebar_active__6-aE3,
.sidebar_sidebarSubListItem__ZkUS9:hover {
  background-color: rgb(240, 240, 255);
}
.sidebar_sidebarSubIcon__NCdPE {
  margin-right: 5px;
  font-size: 16px !important;
}

.sidebar_sidebarList__3XV9A {
  list-style: none;
  padding: 5px;
  color: var(--hsrcDarkBlue);
  font-size: 16px;
  font-family: var(--FontFamily);
}

.sidebar_sidebarListItemDisabled__hl3Nm {
  padding: 5px;
  cursor: default;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 25px;
}

.sidebar_sidebarListItemDisabled__hl3Nm.sidebar_active__6-aE3,
.sidebar_sidebarListItemDisabled__hl3Nm:hover {
  background-color: rgb(240, 240, 255);
}

.sidebar_sidebarListItem__F1ESx {
  padding: 5px;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  flex-shrink: 0;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 25px;
}

.sidebar_sidebarListItem__F1ESx.sidebar_active__6-aE3,
.sidebar_sidebarListItem__F1ESx:hover {
  background-color: rgb(240, 240, 255);
}

.sidebar_sidebarIcon__G54jR {
  margin-right: 5px;
  font-size: 20px !important;
}

.sidebar_hsrc__logo__BUVQQ {
  display: flex;
  align-self: flex-start;
  width: auto;
  height: 90px;

}

.sidebar_logo__3EZqp {
  display: flex;
  /* vertical-align: bottom; */

  width: 160px;
  height: 60px;
  margin-left: 3rem;
  margin-bottom: 3rem;
}

.sidebar_logout__u5kaw {
  display: inline-block;
  border-radius: 50px;
  background-color: var(--hsrcOrange);
  border-color: var(--hsrcOrange);
  border-style: solid;
  border-width: 1rem;
  color: var(--hsrcWhite);
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  transition: all 0.5s;
  /* margin: 15px; */
  letter-spacing: 0.15rem;
  cursor: pointer;
  height: 30px;
  width: auto;
}

.sidebar_avatar__dWJtH {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  /* width: auto; */
  /* height: auto; */
  margin-left: 3rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  border-radius: 15px;
  /* background-color: var(--hsrcDarkYellow); */
  border-color: var(--hsrcDarkYellow);
  border-style: solid;
  border-width: 0.02rem;
  color: var(--hsrcDarkBlue);
  padding: 0.8rem;
  /* text-align: center; */
}

.sidebar_link__2U81P {
  text-decoration: none;
  color: inherit;
}

.sidebar_disabled_link__rXkoO {
  text-decoration: none;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/components/Sidebar/sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;;AAEX;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;;EAEtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,4BAA4B;;EAE5B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ","sourcesContent":[".sidebar {\r\n  display: flex;\r\n  flex: 1;\r\n  height: 100%;\r\n  min-width: 15%;\r\n  max-width: 15%;\r\n  position: sticky;\r\n  overflow: hidden;\r\n  margin-top: 25px;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n\r\n}\r\n\r\n.sidebarWrapper {\r\n  color: var(--hsrcDarkBlue);\r\n  font-size: 16px;\r\n}\r\n\r\n.sidebarMenu {\r\n\r\n  padding: 2rem;\r\n}\r\n\r\n.sidebarTitle {\r\n  font-size: 13px;\r\n  color: rgb(187, 186, 186);\r\n}\r\n\r\n.sidebarSubListItem {\r\n  padding-left: 10px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.sidebarSubListItem.active,\r\n.sidebarSubListItem:hover {\r\n  background-color: rgb(240, 240, 255);\r\n}\r\n.sidebarSubIcon {\r\n  margin-right: 5px;\r\n  font-size: 16px !important;\r\n}\r\n\r\n.sidebarList {\r\n  list-style: none;\r\n  padding: 5px;\r\n  color: var(--hsrcDarkBlue);\r\n  font-size: 16px;\r\n  font-family: var(--FontFamily);\r\n}\r\n\r\n.sidebarListItemDisabled {\r\n  padding: 5px;\r\n  cursor: default;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-shrink: 0;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.sidebarListItemDisabled.active,\r\n.sidebarListItemDisabled:hover {\r\n  background-color: rgb(240, 240, 255);\r\n}\r\n\r\n.sidebarListItem {\r\n  padding: 5px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  flex-shrink: 0;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.sidebarListItem.active,\r\n.sidebarListItem:hover {\r\n  background-color: rgb(240, 240, 255);\r\n}\r\n\r\n.sidebarIcon {\r\n  margin-right: 5px;\r\n  font-size: 20px !important;\r\n}\r\n\r\n.hsrc__logo {\r\n  display: flex;\r\n  align-self: flex-start;\r\n  width: auto;\r\n  height: 90px;\r\n\r\n}\r\n\r\n.logo {\r\n  display: flex;\r\n  /* vertical-align: bottom; */\r\n\r\n  width: 160px;\r\n  height: 60px;\r\n  margin-left: 3rem;\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.logout {\r\n  display: inline-block;\r\n  border-radius: 50px;\r\n  background-color: var(--hsrcOrange);\r\n  border-color: var(--hsrcOrange);\r\n  border-style: solid;\r\n  border-width: 1rem;\r\n  color: var(--hsrcWhite);\r\n  text-align: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  transition: all 0.5s;\r\n  /* margin: 15px; */\r\n  letter-spacing: 0.15rem;\r\n  cursor: pointer;\r\n  height: 30px;\r\n  width: auto;\r\n}\r\n\r\n.avatar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-content: center;\r\n  align-items: center;\r\n  /* width: auto; */\r\n  /* height: auto; */\r\n  margin-left: 3rem;\r\n  margin-bottom: 1rem;\r\n  margin-top: 1rem;\r\n  border-radius: 15px;\r\n  /* background-color: var(--hsrcDarkYellow); */\r\n  border-color: var(--hsrcDarkYellow);\r\n  border-style: solid;\r\n  border-width: 0.02rem;\r\n  color: var(--hsrcDarkBlue);\r\n  padding: 0.8rem;\r\n  /* text-align: center; */\r\n}\r\n\r\n.link {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n.disabled_link {\r\n  text-decoration: none;\r\n  color: red;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `sidebar_sidebar__bs-lW`,
	"sidebarWrapper": `sidebar_sidebarWrapper__3cXMU`,
	"sidebarMenu": `sidebar_sidebarMenu__0ckut`,
	"sidebarTitle": `sidebar_sidebarTitle__lJclU`,
	"sidebarSubListItem": `sidebar_sidebarSubListItem__ZkUS9`,
	"active": `sidebar_active__6-aE3`,
	"sidebarSubIcon": `sidebar_sidebarSubIcon__NCdPE`,
	"sidebarList": `sidebar_sidebarList__3XV9A`,
	"sidebarListItemDisabled": `sidebar_sidebarListItemDisabled__hl3Nm`,
	"sidebarListItem": `sidebar_sidebarListItem__F1ESx`,
	"sidebarIcon": `sidebar_sidebarIcon__G54jR`,
	"hsrc__logo": `sidebar_hsrc__logo__BUVQQ`,
	"logo": `sidebar_logo__3EZqp`,
	"logout": `sidebar_logout__u5kaw`,
	"avatar": `sidebar_avatar__dWJtH`,
	"link": `sidebar_link__2U81P`,
	"disabled_link": `sidebar_disabled_link__rXkoO`
};
export default ___CSS_LOADER_EXPORT___;
